const tag = {
  baseStyle: {
    container: {
      borderRadius: "lg",
      fontFamily: "forms",
      height: "30px",
    },
    label: {
      fontSize: "md",
    },
    closeButton: {
      width: "sp8",
      height: "sp8",
      borderRadius: "md",
    },
  },

  variants: {
    brand: {
      container: {
        background: "brand.400",
        color: "neutrals.0",
      },
    },
    subtle: {
      container: {
        background: "neutrals.40",
        color: "neutrals.900",
        svg: {
          color: "neutrals.200",
        },
      },
    },
    dark: {
      container: {
        background: "#515151",
        color: "neutrals.0",
      },
    },
    green: {
      container: {
        background: "accent.green.100",
        color: "neutrals.900",
        svg: {
          color: "accent.green.500",
        },
      },
    },
    orange: {
      container: {
        background: "accent.orange.100",
        color: "neutrals.900",
        svg: {
          color: "accent.orange.500",
        },
      },
    },
    red: {
      container: {
        background: "accent.red.400",
        color: "neutrals.0",
      },
    },
  },
  sizes: {
    default: {
      container: {
        p: "sp4",
        px: "sp12",
      },
      closeButton: {
        p: "sp4",
      },
    },
    compact: {
      container: {
        px: "sp8",
        py: "sp4",
        borderRadius: "lg",
        height: "24px",
      },
      label: {
        fontSize: "sm",
      },
      closeButton: {
        p: "sp8",
      },
    },
  },
  defaultProps: {
    size: "default",
    variant: "primary",
  },
};

export default tag;
